import { render, staticRenderFns } from "./MyPageDialog.vue?vue&type=template&id=2080bdc6&scoped=true"
import script from "./MyPageDialog.vue?vue&type=script&lang=js"
export * from "./MyPageDialog.vue?vue&type=script&lang=js"
import style0 from "./MyPageDialog.vue?vue&type=style&index=0&id=2080bdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080bdc6",
  null
  
)

export default component.exports